import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './authorize.service';

/**
 * Lässt nur SuperAdmin und die kaufmännische Gruppe in die Ressourcenplanung.
 */
@Injectable({
  providedIn: 'root'
})
export class ResourcePlanningGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): boolean {
    if (this.authService.isAuthenticated() && this.authService.canSeeResourcePlanning()) {
      return true;
    }
    this.router.navigate(['/home']);
    return false;
  }
}
